module.exports = __webpack_public_path__ + "b8bbfe80f448d46c25a4a15d442f2e72.svg";